var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"show-select":_vm.totaleTotem > 0,"item-key":"_id","headers":_vm.headers,"items":_vm.elencoTotem,"options":_vm.options,"server-items-length":_vm.totaleTotem,"loading":_vm.loading,"disable-sort":true,"footer-props":{
          itemsPerPageOptions: [5, 10, 15, 50, 100],
        },"single-expand":_vm.singleExpand,"expanded":_vm.expanded,"show-expand":"","dense":""},on:{"update:options":function($event){_vm.options=$event},"update:expanded":function($event){_vm.expanded=$event},"item-expanded":_vm.onItemExpanded},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',[_vm._v("Gestione totem")]),_c('v-spacer')],1)]},proxy:true},{key:`item.actions`,fn:function({ item }){return [_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[_c('v-icon',{staticClass:"mt-1",attrs:{"title":"Esporta configurazione"},on:{"click":function($event){return _vm.esportaConfigurazione(item)}}},[_vm._v("mdi-download-multiple-outline")])],1),_c('v-col',{attrs:{"title":"Importa configurazione"}},[_c('v-file-input',{staticClass:"mt-0",attrs:{"dense":"","hide-input":"","hide-details":"","accept":".json","prepend-icon":"mdi-upload-multiple-outline"},on:{"change":function($event){return _vm.importaConfigurazione($event, item)}},model:{value:(_vm.filename),callback:function ($$v) {_vm.filename=$$v},expression:"filename"}})],1),_c('v-spacer')],1)]}},{key:"expanded-item",fn:function({ headers, item }){return [_c('td',{staticClass:"articoliSelected",attrs:{"colspan":headers.length}},[_c('v-tabs',{attrs:{"dense":""},model:{value:(_vm.tab[item._id]),callback:function ($$v) {_vm.$set(_vm.tab, item._id, $$v)},expression:"tab[item._id]"}},[_c('v-tab',{key:"configurazione",staticClass:"articoliSelected"},[_vm._v("Template")]),_c('v-tab',{key:"tema"},[_vm._v("Tema")]),_c('v-tab',{key:"dettaglioProdotti"},[_vm._v("Dettaglio prodotti")]),_c('v-tab',{key:"ordinaProdotti"},[_vm._v("Ordina prodotti")]),_c('v-tab',{key:"allegati"},[_vm._v("Immagini")]),_c('v-tab',{key:"testi"},[_vm._v("Testi e lingue")])],1),_c('v-tabs-items',{model:{value:(_vm.tab[item._id]),callback:function ($$v) {_vm.$set(_vm.tab, item._id, $$v)},expression:"tab[item._id]"}},[_c('v-tab-item',{key:"configurazione"},[_c('configurazione',{attrs:{"item":item}})],1),_c('v-tab-item',{key:"tema"},[_c('tema',{attrs:{"item":item}})],1),_c('v-tab-item',{key:"dettaglioProdotti"},[_c('dettaglio-prodotti',{attrs:{"item":item,"refresh":_vm.trigRefreshProdotti},on:{"aggiorna":_vm.aggiornaTotem}})],1),_c('v-tab-item',{key:"ordinaProdotti"},[_c('ordina-prodotti',{attrs:{"item":item,"refresh":_vm.trigRefreshProdotti},on:{"aggiorna":_vm.aggiornaOrdine}})],1),_c('v-tab-item',{key:"allegati"},[_c('immagini',{attrs:{"codiceTotem":item.codice,"alberaturaAssets":item.alberaturaAssets,"triggerUpdate":_vm.triggerUpdate},on:{"change":_vm.onChangeFile,"refresh":_vm.refresh,"sincronizza":_vm.sincronizzaProdotti,"prima-installazione":_vm.onPrimaInstallazione}})],1),_c('v-tab-item',{key:"testi"},[_c('v-expansion-panels',{staticClass:"mt-2",attrs:{"multiple":""}},_vm._l((_vm.languages),function(language,index){return _c('v-expansion-panel',{key:index,staticClass:"mb-2",staticStyle:{"border":"1px solid #e0e0e0"}},[_c('v-expansion-panel-header',[_c('div',{staticClass:"d-flex justify-start align-center"},[_c('v-checkbox',{model:{value:(language.isChecked),callback:function ($$v) {_vm.$set(language, "isChecked", $$v)},expression:"language.isChecked"}}),_c('h2',[_vm._v(_vm._s(language.name))])],1)]),_c('v-expansion-panel-content',[_c('language-input',{attrs:{"item":language.text,"path":[index, 'text']},on:{"mutate":_vm.changeLanguage}})],1)],1)}),1),_c('v-btn',{staticClass:"mt-2 mb-3",attrs:{"color":"success","loading":_vm.saving},on:{"click":function($event){$event.stopPropagation();return _vm.salvaLingue(item.codice)}}},[_vm._v("Salva modifiche")])],1)],1)],1)]}}],null,true),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1),(_vm.mostraAnteprima)?_c('v-col',{attrs:{"cols":"3"}},[_c('div',{staticStyle:{"position":"sticky","top":"100px"}},[_c('div',{staticClass:"d-flex justify-between align-center"},[_c('h1',[_vm._v("Anteprima totem")]),_c('v-switch',{staticClass:"ms-auto",attrs:{"label":"Contrasto"},model:{value:(_vm.themeIndex),callback:function ($$v) {_vm.themeIndex=$$v},expression:"themeIndex"}})],1),_c('v-col',{style:({
            height: '70vh',
            ...this.convertToStyle('screen layout background', {
              background: _vm.configFromPath([
                'globalConfig',
                'screen-layout',
                'value',
                'background',
              ]),
            }),
            padding: '20px',
          })},[_c('v-row',{style:({
              ...this.convertToStyle(
                'screen header style',
                _vm.configFromPath([
                  'globalConfig',
                  'screen-layout',
                  'value',
                  'header',
                  'style',
                ])
              ),
              height: '10%',
              marginBottom: '10px',
              borderRadius: '10px',
            })},[_c('div',{staticClass:"d-flex justify-space-between align-center",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"ms-2 rounded d-flex justify-center align-center",staticStyle:{"height":"50%","aspect-ratio":"2/1"},style:({
                  ..._vm.convertToStyle(
                    'product category background',
                    _vm.configFromPath([
                      'globalConfig',
                      'screen-layout',
                      'value',
                      'header',
                      'back-btn',
                    ])
                  ),
                })},[_vm._v(" Button ")]),_c('div',{staticClass:"d-flex justify-center align-center rounded-pill",staticStyle:{"height":"50%","aspect-ratio":"2/1","background-color":"white"}},[_c('h3',[_vm._v("LOGO")])]),_c('div',{staticClass:"me-2 rounded d-flex justify-center align-center",staticStyle:{"height":"50%","aspect-ratio":"2/1"},style:({
                  ..._vm.convertToStyle(
                    'product category background',
                    _vm.configFromPath([
                      'globalConfig',
                      'screen-layout',
                      'value',
                      'header',
                      'order-btn',
                    ])
                  ),
                })},[_vm._v(" Button ")])])]),_c('v-row',{style:({
              height: '80%',
            })},[_c('v-col',{style:({
                ..._vm.convertToStyle('product sidebar', {
                  background: _vm.configFromPath([
                    'configurations',
                    '2',
                    'config',
                    'sidebar',
                    'value',
                    'background',
                  ]),
                }),
                borderRadius: '10px',
              }),attrs:{"cols":"3"}},[_c('div',{style:({
                  ...this.convertToStyle(
                    'product selected',
                    _vm.configFromPath([
                      'configurations',
                      '2',
                      'config',
                      'sidebar',
                      'value',
                      'selected',
                    ])
                  ),
                  borderRadius: '10px',
                  marginBottom: '10px',
                  height: '50px',
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                })},[_vm._v(" C"+_vm._s(1)+" ")]),_vm._l((4),function(i){return _c('div',{key:i,style:({
                  ..._vm.convertToStyle('product category background', {
                    background: _vm.configFromPath([
                      'globalConfig',
                      'productPopup',
                      'value',
                      'category',
                      'background',
                    ]),
                  }),
                  ..._vm.convertToStyle('category title text', {
                    text: _vm.configFromPath([
                      'globalConfig',
                      'productPopup',
                      'value',
                      'category',
                      'title',
                      'text',
                    ]),
                  }),
                  borderRadius: '10px',
                  marginBottom: '10px',
                  height: '50px',
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                })},[_vm._v(" C"+_vm._s(i + 1)+" ")])})],2),_c('v-col',{attrs:{"cols":"9"}},[_c('div',{staticClass:"d-flex flex-wrap",staticStyle:{"align-items":"start","justify-content":"space-evenly"}},_vm._l((8),function(i){return _c('div',{key:i,style:({
                    ..._vm.convertToStyle(
                      'product background',
                      _vm.configFromPath([
                        'globalConfig',
                        'productCard',
                        'value',
                        'style',
                      ])
                    ),
                    borderRadius: '10px',
                    marginBottom: '10px',
                    marginRight: '10px',
                    width: '40%',
                    height: '100px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'black',
                  })},[_vm._v(" P"+_vm._s(i)+" ")])}),0)])],1)],1)],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }